const state = () => ({
  showBottomNavigation: true,
  buttonsSettings: []
});

const getters = {
  showBottomNavigation(state) {
    return state.showBottomNavigation;
  },
  buttonsSettings(state) {
    return state.buttonsSettings;
  }
};

const mutations = {
  setShowBottomNavigation(state, payload) {
    state.showBottomNavigation = payload;
  },
  setButtonsSettings(state, payload) {
    state.buttonsSettings = payload;
  }
};

export const bottomNavigation = {
  state,
  getters,
  mutations,
  namespaced: true
};
